import { BusinessStatusType } from '@/api/backend/types';
import { Badge } from '@opaz/ui-components';
import { useTranslation } from 'react-i18next';

type BadgeType = 'positive' | 'negative' | 'warning' | 'neutral' | 'brand' | null | undefined;

const businessStatusToBadgeTypeMap: Record<BusinessStatusType, BadgeType> = {
  draft: 'neutral',
  processing: 'warning',
  completed: 'positive',
  rejected: 'negative',
  canceled: 'negative',
  pendingChanges: 'brand',
  pendingPayment: 'brand',
};

type ProcessStatusBadgeProps = {
  businessStatus: BusinessStatusType;
  completed?: boolean;
};

export const ProcessStatusBadge = ({ businessStatus, completed = false }: ProcessStatusBadgeProps) => {
  const { t } = useTranslation();

  return businessStatus ? (
    <Badge
      className="whitespace-nowrap"
      type={businessStatusToBadgeTypeMap[businessStatus as BusinessStatusType]}
      filled={businessStatus === 'draft'}
    >
      {t([`processInstance.status.${businessStatus as BusinessStatusType}`, 'processInstance.status.unknown'])}
    </Badge>
  ) : (
    <Badge type={completed ? 'positive' : 'neutral'} className="whitespace-nowrap">
      {t(`processInstance.status.${completed ? 'completed' : 'unknown'}`)}
    </Badge>
  );
};
